import { ResponsivePie } from '@nivo/pie';
import React from 'react';

// eslint-disable-next-line react/prop-types
function DoughnutChart({ data }) {
  return (
    <div style={{ height: '300px' }}>
      <ResponsivePie
        data={data}
        margin={{ top: 40, right: 80, bottom: 80, left: 80 }}
        innerRadius={0.5}
        padAngle={0.7}
        cornerRadius={3}
        activeOuterRadiusOffset={8}
        borderWidth={1}
        borderColor={{
          from: 'color',
          modifiers: [['darker', 0.2]],
        }}
        arcLinkLabel={(e) => `${e.data.newValue} (${e.value}%)`}
        arcLinkLabelsSkipAngle={10}
        arcLinkLabelsTextColor="#333333"
        arcLinkLabelsThickness={2}
        isInteractive={false}
        arcLinkLabelsColor={{ from: 'color' }}
        arcLabelsSkipAngle={10}
        arcLabelsTextColor={{
          from: 'color',
          modifiers: [['darker', 2]],
        }}
      // legends={[
      //   {
      //     anchor: 'bottom',
      //     direction: 'column',
      //     justify: false,
      //     translateX: -89,
      //     translateY: 170,
      //     itemsSpacing: 17,
      //     itemWidth: 117,
      //     itemHeight: 30,
      //     itemTextColor: '#999',
      //     itemDirection: 'left-to-right',
      //     itemOpacity: 1,
      //     symbolSize: 12,
      //     symbolShape: 'circle',
      //     effects: [
      //       {
      //         on: 'hover',
      //         style: {
      //           itemTextColor: '#000',
      //         },
      //       },
      //     ],
      //   },
      // ]}
      />
    </div>
  );
}

export default DoughnutChart;
